import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdminStudentsResponse, StudentFilterParams, StudentManagementResponse, StudentSearchResponse } from '@edtech-ui/core/models/admin-panel/admin-panel-models';
import { InviteStudentRequest, InviteStudentResponse } from '@edtech-ui/core/models/admin-panel/invite-student.model';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class StudentManagementService {

    constructor(private http: HttpClient) { }
    apiUrl = environment.adminDashboardUrl;

    inviteStudent(payload: InviteStudentRequest) {
        return this.http.post<InviteStudentResponse>(
            `${this.apiUrl}${environment.adminDashboardEndpoints.inviteStudent}`,
            payload
        );
    }

    getFilteredStudents(params: StudentFilterParams) {
        const query: any = {
            filter_type: params.filter_type,
            page: params.page ?? 1,
            limit: params.limit ?? 10,
        };

       if (params.batch_id !== 'All') query.batch_id = params.batch_id;
       if (params.department_id !== 'All') query.department_id = params.department_id;
       if (params.search && params.search.trim() !== '') {
       query.search = params.search;
        }

        return this.http.get<AdminStudentsResponse>(
            `${environment.adminApiUrl}/admin_students`,
            { params: query }
        );
    }
    searchStudents(query: string) {
        return this.http.get<StudentSearchResponse>(
            `${environment.adminApiUrl}${environment.adminDashboardEndpoints.searchStudents}?query=${query}`
        );
    }
}
